import React from "react";
import { DatePicker } from "antd";

const { RangePicker } = DatePicker;
export const AllRangePicker = ({
  onChange,
  value,
  disabledDate,
  format,
  showTime,
  disabled,
  filter,
  name,
  required,
}) => {
  return (
    <>
      {!filter && (
        <label className="font-weight-bolder font-size-lg">
          {name} {required && <span style={{ color: "red" }}>*</span>}
        </label>
      )}
      <div className="select_date fullcenter">
        <RangePicker
          format={format ? format : "DD MMM, YYYY"}
          showTime={showTime}
          className="w-100 rounded-sm py-2"
          value={value}
          disabledDate={disabledDate}
          onChange={onChange}
          disabled={disabled}
        />
      </div>
    </>
  );
};
